import { PATH_CONFIG } from "./paths.config";
import { ROUTES_CONFIG } from "./route.config";

export const environment = {
    idCentroComercial:25,
    centroComercial:'CRMPORTAL80',
    routeLogin:'./dashboard/estadistica/sendNotification',
    routeLoginClient:'./dashboard/facturas/register',
    imageIcon:'https://www.portal80.com.co//wp-content/uploads/2025/06/cropped-logoCC80.png',
    paths:PATH_CONFIG,
    ...ROUTES_CONFIG,
    jumpCube:true
};
